import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Row, Col, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import { cw, hp } from "../../utils";

import Esoko from '../../assets/img/auth/esoko.svg';

const Reset = (props) => {
    const { intl, _utils } = props;

    const [token] = useState(window.location.pathname.split('/')[3]);
    const [validx, setValidx] = useState(false);
    const [reseting, setReseting] = useState(false);

    const [resetForm] = Form.useForm();
    const [verifyForm] = Form.useForm();
    const [changePasswordForm] = Form.useForm();

    const asyncEmail = async (_, value) => {
        if (value) {
            return axios({
                method: 'GET',
                url: `${hp.getApiBaseUrl()}/auth/validations/emails/${value.trim().toLowerCase()}`,
                json: true
            }).then((response) => {
                const res = response.data;
                if (res.statusCode === 200 && res.data.userExists === false) {
                    return Promise.reject(`${value} does not exist`);
                }
                return Promise.resolve();
            }).catch(() => {
                return Promise.reject(`${value} does not exist`);
            });
        }
        return Promise.resolve();
    };

    const confirmPasswordMatch = (_, value) => {
        if (value !== changePasswordForm.getFieldValue('password')) {
            return Promise.reject('Passwords do not match');
        }
        return Promise.resolve();
    };

    const _reset = (vals) => {
        setReseting(true);
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/auth/password-reset-requests`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Origin': window.location.origin
            },
            data: { email: vals.userName.trim().toLowerCase() }
        }).then((response) => {
            setReseting(false);
            const res = response.data;
            switch (res.statusCode) {
                default:
                    notification.error({
                        message: intl.formatMessage(cw['Success']),
                        description: intl.formatMessage(cw['ResetPassword.Failed'])
                    });
                    break;
                case 200:
                    notification.success({
                        message: intl.formatMessage(cw['Success']),
                        description: intl.formatMessage(cw['ResetPassword.Success'])
                    });
                    window.location.assign(`/en/reset/${res.data.id}${window.location.search}`);
                    break;
            }
        }).catch(() => {
            setReseting(false);
            notification.error({
                message: intl.formatMessage(cw['Success']),
                description: intl.formatMessage(cw['ResetPassword.Failed'])
            });
        });
    };

    const verifyResetToken = (v) => {
        if (token) {
            setReseting(true);
            axios({
                method: 'GET',
                url: `${hp.getApiBaseUrl()}/auth/password-reset-requests/${token}/tokens/${v.token}`,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                setReseting(false);
                const res = response.data;
                if (res.statusCode === 200) {
                    setValidx(true);
                } else {
                    notification.error({ message: res.message });
                }
            }).catch((err) => {
                const res = JSON.parse((err.request || '').response);
                setReseting(false);
                setValidx(false);
                notification.error({ message: res.message });
            });
        }
    };

    const _changePwd = (data) => {
        const lang = _utils && _utils.lang;
        setReseting(true);
        axios({
            method: 'PUT',
            url: `${hp.getApiBaseUrl()}/auth/password-resets/${token}`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            data
        }).then(response => {
            setReseting(false);
            const res = response.data;
            if (res.statusCode === 200) {
                notification.success({
                    message: intl.formatMessage(cw['Success']),
                    description: intl.formatMessage(cw['ChangePassword.Success'])
                });
                setTimeout(() => {
                    window.location.assign(`/${lang || 'en'}/signin${window.location.search}`);
                }, 400);
            } else {
                notification.error({
                    message: intl.formatMessage(cw['Failed']),
                    description: intl.formatMessage(cw['ChangePassword.Failed'])
                });
            }
        }).catch(() => {
            setReseting(false);
            notification.error({
                message: intl.formatMessage(cw['Failed']),
                description: intl.formatMessage(cw['ChangePassword.Failed'])
            });
        });
    };

    return (
        <React.Fragment>
            {/* ::: reset */}
            {!token && (
                <Form id="esoko__signin" form={resetForm} layout="vertical" requiredMark={false} onFinish={_reset}>
                    <img src={Esoko} alt="Esoko" />
                    <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_title" defaultMessage="Reset your password" /></div>
                    <p className="auth_form_description info">
                        <FormattedMessage id="Reset.Title" defaultMessage="Initiate password reset process by providing your email address below" />
                    </p>
                    <Row gutter={16}>
                        <Col span={24}>
                            <div>
                                <Form.Item
                                    colon={false}
                                    label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}
                                    name="userName"
                                    validateTrigger={['onChange', 'onBlur']}
                                    rules={[
                                        { required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> },
                                        { validator: asyncEmail }
                                    ]}
                                >
                                    <Input size="large" type="text" autoComplete="off" autoFocus placeholder="you@domain.com" sso-id="reset-email" />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                    <Form.Item noStyle shouldUpdate>
                        {() => (
                            <Button
                                loading={reseting}
                                htmlType="submit"
                                type="primary"
                                size="large"
                                className="esoko__button"
                                disabled={
                                    !resetForm.isFieldsTouched(['userName'], true) ||
                                    resetForm.getFieldsError().filter(({ errors }) => errors.length).length > 0
                                }
                                sso-id="reset-submit"
                            >
                                <FormattedMessage id="Button.Reset" defaultMessage="Reset Password" />
                            </Button>
                        )}
                    </Form.Item>
                    <div className="formLinks">
                        <p style={{ paddingTop: '5%' }}>
                            <span className="noAccountText"><FormattedMessage id="Button.AlreadyHaveAccount" defaultMessage="Already have an account?" /></span>
                            <Link to={`/${(_utils && _utils.lang) || 'en'}/signin${window.location.search}`} sso-id="login-link"><FormattedMessage id="Button.SignIn" defaultMessage="Sign in" /></Link>
                        </p>
                    </div>
                </Form>
            )}

            {token && !validx && (
                <Form id="esoko__signin" form={verifyForm} layout="vertical" onFinish={verifyResetToken} className="resetPassword" requiredMark={false}>
                    <img src={Esoko} alt="Esoko" />
                    <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_verify_title" defaultMessage="Enter verification code" /></div>
                    <p className="auth_form_description warning">
                        <FormattedMessage id="Reset.Reset.Title" defaultMessage="A 6-digit code was sent to your email address. Enter the code you received below" />
                    </p>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                colon={false}
                                label={<FormattedMessage id="loginForm.VerificationCode" defaultMessage="Verification code" />}
                                name="token"
                                rules={[
                                    { required: true, message: <FormattedMessage id="Rules.VerificationCode.Required" defaultMessage="Please provide verification code" /> }
                                ]}
                            >
                                <Input size="large" type="text" placeholder="******" sso-id="reset-token" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ marginTop: '.7rem', marginBottom: '1rem' }}>
                        <Form.Item noStyle shouldUpdate>
                            {() => (
                                <Button
                                    loading={reseting}
                                    htmlType="submit"
                                    type="primary"
                                    size="large"
                                    className="esoko__button"
                                    disabled={
                                        !verifyForm.isFieldsTouched(['token'], true) ||
                                        verifyForm.getFieldsError().filter(({ errors }) => errors.length).length > 0
                                    }
                                    sso-id="reset-verify-submit"
                                >
                                    <FormattedMessage id="resetPassword.Confirm" defaultMessage="Confirm" />
                                </Button>
                            )}
                        </Form.Item>
                    </div>
                    <div className="formLinks">
                        <p style={{ paddingTop: '5%' }}>
                            <span className="noAccountText"><FormattedMessage id="Button.AlreadyHaveAccount" defaultMessage="Already have an account?" /></span>
                            <Link to={`/${(_utils && _utils.lang) || 'en'}/signin${window.location.search}`} sso-id="login-link"><FormattedMessage id="Button.SignIn" defaultMessage="Sign in" /></Link>
                        </p>
                    </div>
                </Form>
            )}

            {token && validx && (
                <Form id="esoko__signin" form={changePasswordForm} layout="vertical" onFinish={_changePwd} className="resetPassword" requiredMark={false}>
                    <img src={Esoko} alt="Esoko" />
                    <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_change_password" defaultMessage="Change your password" /></div>
                    <p className="auth_form_description info">
                        <FormattedMessage id="Reset.Reset.Confirm.Title" defaultMessage="Provide your password bellow" />
                    </p>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                colon={false}
                                label={<FormattedMessage id="Label.NewPassword" defaultMessage={'New Password'} />}
                                name="password"
                                rules={[
                                    { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                    { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> }
                                ]}
                            >
                                <Input size="large" type="password" placeholder="******" sso-id="reset-password" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                colon={false}
                                label={<FormattedMessage id="Label.ConfirmPassword" defaultMessage={'Confirm Password'} />}
                                name="confirmPassword"
                                rules={[
                                    { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                    { validator: confirmPasswordMatch },
                                    { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> }
                                ]}
                            >
                                <Input size="large" type="password" placeholder="******" sso-id="reset-confirm-password" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ marginTop: '.7rem', marginBottom: '1rem' }}>
                        <Button block type="primary" size="large" htmlType="submit" className="submitBtn" loading={reseting} sso-id="reset-change-button">
                            <FormattedMessage id="resetPassword.ChangePassword" defaultMessage="Change Password" />
                        </Button>
                    </div>
                </Form>
            )}
        </React.Fragment>
    );
};

export default Reset;
